import { FC, useState } from 'react';
import DropdownAutocomplete from 'view/components/DropdownAutocomplete';
import { useGetDropdownData } from 'view/pages/profile/hooks/useGetDropdownData';
import { DropdownsEnum } from 'infrastructure/enums/DropdownsEnum';

const JobTitleDropdownAutocomplete: FC<any> = ({ setValue, jobTitleValue }) => {
  const [inputValue, setInputValue] = useState('');

  const { data: jobTitleData, isLoading: isJobTitleDataLoading } = useGetDropdownData(
    DropdownsEnum.JOB_TITLE
  );

  return (
    <DropdownAutocomplete
      label="Job Title / Role"
      value={jobTitleValue}
      onChange={(value: any) => {
        return setValue('jobTitle', value);
      }}
      inputValue={inputValue}
      setInputValue={setInputValue}
      data={jobTitleData}
      isLoading={isJobTitleDataLoading}
      getOptionLabel={(option: any) => {
        return `${option.name}`;
      }}
    />
  );
};

export default JobTitleDropdownAutocomplete;
